document.querySelectorAll('.accelerated-checkout-block').forEach((container) => {
  const iconsEl = container.nextElementSibling;
  if (!iconsEl || !iconsEl.classList.contains('pdp-payment-icons')) return;

  function place() {
    const moreLink = container.querySelector('more-payment-options-link');
    if (!moreLink) return false;
    iconsEl.hidden = false;
    moreLink.parentNode.insertBefore(iconsEl, moreLink);
    return true;
  }

  if (place()) return;

  const observer = new MutationObserver(() => {
    if (place()) observer.disconnect();
  });
  observer.observe(container, { childList: true, subtree: true });

  // Safety net: if no "more payment options" link ever appears (e.g. only one
  // payment method is available), still show the icons after the button —
  // unless the checkout block itself is intentionally hidden (sold out).
  setTimeout(() => {
    observer.disconnect();
    if (iconsEl.hidden && !container.hidden) {
      iconsEl.hidden = false;
      container.after(iconsEl);
    }
  }, 6000);
});
